import type { FC } from 'react'
import { GrandHeading } from 'ui'

interface IBrandTitleProps {
  title: string
}

const BrandTitle: FC<IBrandTitleProps> = ({ title }) => {
  return (
    <GrandHeading
      color="text.mild"
      cursor="pointer"
      fontSize={['xs', 'sm', 'md']}
      fontWeight="medium"
      headingTag="h2"
      my={0}
      textAlign={{ base: 'left' }}
      textTransform="uppercase"
      title={title}
    />
  )
}

export default BrandTitle
